import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=38f19611&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventCard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventCard.vue?vue&type=style&index=0&id=38f19611&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f19611",
  null
  
)

export default component.exports